import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../services/Backend";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import DeleteIcon from '@mui/icons-material/Delete';
import { SuccessToast } from "../utils/utils";
import DeleteButton from "../components/DeleteButton";

export default function AdminListPage() {
  const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const [admins, setAdmins] = useState([]);
    
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);

      Backend.get(`user/admins?page=${newPage}`)
      .then(res => {
          setTotalCount(res.totalCount);
          setAdmins(res.data);
          setIsLoading(false);
      });
    };

    useEffect(() => {
      Backend.get(`user/admins?page=${page}`)
        .then(res => {
            setTotalCount(res.totalCount);
            setAdmins(res.data);
            setIsLoading(false);
        });
    }, []);

    const goToAdminPage = (id) => {
        navigate(`/dashboard/users/${id}`);
    }

    const deleteAdmin = (e, id) => {
      e.preventDefault();
      e.stopPropagation();

      Backend.delete(`user/${id}`)
        .then(res => {
            SuccessToast("Admin deleted");
            setTimeout(() => window.location.href = '/dashboard/admins', 1000);
        });
    } 

    const getSubscriptionName = (id) => { 
      switch(id) {
        case 1:
          return "Free";
        case 2:
          return "Basic";
        case 3:
          return "Premium";
      }
    }

    return <div>
    <Link to="/dashboard/new-admin"><Button variant="contained">Add new admin</Button></Link>
    <br />
    <br />
    {isLoading ? <div className="mx-auto mt-4 w-fit"><Loader /></div> : <>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow className="bg-slate-950">
            <TableCell>Id</TableCell>
            <TableCell>Full name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Interest</TableCell>
            <TableCell>Language</TableCell>
            <TableCell>Subscription</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {admins.reverse().map((row) => (
            <TableRow key={row.id} onClick={() => goToAdminPage(row.id)}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.firstName} {row.lastName}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.interest}</TableCell>
              <TableCell>{row.language}</TableCell>
              <TableCell>{getSubscriptionName(row.subscriptionId)}</TableCell>
              <TableCell><DeleteButton onClick={(e) => deleteAdmin(e,row.id)}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
          rowsPerPageOptions={10}
          component="div"
          count={totalCount}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </>}
    </div>
}